export const ADVISOR_REDIRECTS = [
  { from: "/chat", to: "/dashboard?view=advisor" },
  { from: "/advisor", to: "/dashboard?view=advisor" },
  { from: "/documents", to: "/dashboard?view=documents" },
] as const;
